module.exports = __webpack_public_path__ + "static/media/call-answer.9b4b0e57.svg";